import React from 'react';
import styled from 'styled-components';
import { Container, FlexContainer } from '../styles/StyledComponents';

const FooterContainer = styled.footer`
  background-color: white;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  padding: 1.5rem 0;
  margin-top: 3rem;
`;

const Copyright = styled.p`
  font-size: 1rem;
  color: var(--text-color);
  text-align: center;
`;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <Container>
        <FlexContainer direction="column">
          <Copyright>
            &copy; {currentYear} Kid Games - Educational Games for Children
          </Copyright>
        </FlexContainer>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
